<template lang="pug">
  v-row()
    v-col
      h1.mb-4 Записать сотрудников на курс

      v-row
        v-col(cols=12 md=6)
          v-card.sdo-card.mb-4
            v-card-text
              v-skeleton-loader(
                v-if="loading.init"
                type="list-item@3"
              )
              template(v-else)
                .d-flex
                  .title Выбранные сотрудники
                  v-spacer
                  v-btn(
                    fab
                    depressed
                    @click="choicePerson"
                  )
                    v-icon mdi-account-multiple-plus
                template(v-if="noEnrolledUsers.length")
                  .mb-3
                    span Всего
                    strong.ml-1 {{ noEnrolledUsers.length }}
                  v-list(nav).pl-0
                    enrollment-employee-item(
                      v-for="item in noEnrolledUsers"
                      :key="item.id"
                      :item="item"
                      :loading="loading.remove[item.id]"
                      :isValid="isValid(item)"
                      :selected="staffs.selected"
                      @select="staffs.selected = $event"
                      @remove="removeStaff($event)"
                    )

                template(v-else)
                  .mb-6 Выберите сотрудников для записи

                v-btn(
                  block
                  color="secondary"
                  large
                  :disabled="!canEnroll"
                  :loading="loading.save"
                  @click="openCreateContractModal"
                ) Записать сотрудников
          v-expansion-panels
            v-expansion-panel.sdo-card(
              v-for="([title, users], index) in Object.entries(enrolledUsers)"
              :key="index"
            )
              v-expansion-panel-header
                div.mb-3
                  .title Сотрудники по договору {{title}}
                  span Всего
                  strong.ml-1 {{ users.length }}
              v-expansion-panel-content
                v-list(
                    nav
                  ).pl-0
                    enrollment-employee-item(
                      v-for="item in users"
                      :key="item.id"
                      :item="item"
                      :loading="loading.remove[item.id]"
                      :isValid="isValid(item)"
                      only-view
                      :selected="staffs.selected"
                      @select="staffs.selected = $event"
                      @remove="removeStaff($event)"
                    )
        v-col()
          v-alert( type="warning" text).
            Заполните персональные данные обучающихся сейчас, либо обеспечьте предоставление
            указанных сведений обучающимися самостоятельно
            (сделать это они смогут в разделе курса своих личных кабинетов).
            Обучающиеся не будут приняты на обучение, пока не внесут
            предусмотренную информацию о себе.
          //- Заполните обязательные для формирования договора данные обучающихся,
          //- предусмотренные требованиями Правил оказания платных образовательных услуг
          course-registration-staff-form(
            v-if="staffs.selected"
            :user="staffs.selected"
            :record-id="enrollmentId"
            @saved="onSaveForm"
          )
</template>
<script>
import PickStaff from '@/components/Layout/ModalsController/types/PickStaff.vue';
import VirtualSelect from '@/components/VirtualSelect.vue';
import FileUpload from '@/components/InputFields/FileUpload.vue';
import EnrollmentEmployeeItem from '@/components/Enrollment/EnrollmentEmployeeItem.vue';
import CreateContractModal from '@/components/Enrollment/CreateContractModal.vue';
import CourseRegistrationStaffForm from './CourseRegistrationStaffForm.vue';

export default {
  name: 'StaffSender',
  components: {
    PickStaff,
    FileUpload,
    VirtualSelect,
    CourseRegistrationStaffForm,
    EnrollmentEmployeeItem,
  },
  data() {
    return {
      enrolledUsers: [],
      noEnrolledUsers: [],
      contracts: [],
      registredTeachers: [],
      staffs: {
        requestId: null,
        items: [],
        selected: null,
        priorRecord: null,
        readyToRecord: false,
      },
      newStaff: [],
      agreementsStaffCards: [],

      loading: {
        init: true,
        save: false,
        remove: {},
      },

      pagination: {
        total: null,
      },
    };
  },
  computed: {
    courseId() {
      return +this.$route.params.courseId;
    },
    enrollmentId() {
      return +this.$route.params.enrollmentId;
    },
    // TODO: Update for role operator && department
    canEnroll() {
      const res = this.course.price
        ? this.noEnrolledUsers.length > 0
        : this.registredTeachers.length === 0;
      return res;
      // return this.staffs.items.length && this.staffs.items.every((i) => this.isValid(i));
    },
    someEnrolled() {
      return this.staffs.items.some((i) => i.status === this.$conf.USER_STATUS_RECORD.credited)
        || !this.staffs.items.length;
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.loading.init = true;
      if (this.$user.isOrganization) await this.getRegistredTeacher();
      await this.getStaffRecords();
      await this.fetchCourse();
      await this.fetchContracts();
      this.loading.init = false;
    },
    getRegistredTeacher() {
      this.$rHandler(
        this.$api.teachers.getRegistredOrganizationStaff(this.courseId),
        (response) => {
          this.registredTeachers = response.data.data;
        },
      );
    },
    async fetchCourse() {
      // await this.$api.system.getTeacherLevels();
      const { item } = await this.$api.courses.show(this.courseId, { expand: 'organization' });
      this.course = item;
    },
    async fetchContracts() {
      const params = {
        expand: 'users,preview_document',
        'search[prior_record_id]': this.enrollmentId,
        'search[owner_id]': this.$user.data.id,
        'search[is_active]': true,
      };
      const { data } = await this.$api.contracts.getContracts(params);
      this.contracts = data.data;
      this.enrolledUsers = data.data.reduce((acc, item) => {
        const { number, users } = item;
        acc[number] = users.map((i2) => {
          const result = this.staffs.items.find((i) => i.id === i2.id);
          return result;
        });
        return acc;
      }, {});
      this.noEnrolledUsers = this.staffs.items.filter((item) => {
        const usersEnrolled = [].concat(...Object.values(this.enrolledUsers));
        return !usersEnrolled.some((i) => i.id === item.id);
      });
    },
    openCreateContractModal() {
      if (this.course.price) {
        this.$modals.show('generic-controller', {
          title: 'Заключение договора',
          component: CreateContractModal,
          dialogProps: {
            persistent: true,
            width: 1000,
          },
          'component-props': {
            organizationId: this.course.organization.id,
            price: this.course.price,
            // readyContract: contract || null,
            params: {
              expand: 'document',
              'search[course_id]': this.courseId,
            },
            employees: this.noEnrolledUsers,
            method: (val) => this.submitStaffs(val),
            successCallback: (id) => {
              // this.init();
              this.$modals.close();
              this.$router.push({ name: 'ListEnrollments', query: { id } });
            },
          },
        });
      } else this.staffRecordsMake();
    },
    isValid(item) {
      return (!item.attributes || !item.attributes.length) || item
        .attributes.every((i) => (i.value || !i.is_required));
    },
    getTooltipText(item) {
      const staffStatus = item.status === this.$conf.USER_STATUS_RECORD.credited
        ? 'Сотрудник зачислен'
        : 'Сотрудник не зачислен';
      const validationStatus = !this.isValid(item) ? '. Не все обязательные поля заполнены' : '';
      return `${staffStatus}${validationStatus}`;
    },
    getStaffRecords() {
      return this.$rHandler(
        this.$api.courses.staffRecordsShow(this.enrollmentId),
        (response) => {
          const request = response.data.data;
          if (request) {
            this.staffs.requestId = request.id;
            this.staffs.items = request.users;
            this.staffs.priorRecord = request.prior_record;
          }
          this.pagination.total = this.staffs.items.length;
        },
      );
    },
    async staffRecordsMake() {
      await this.$rHandler(
        this.$api.courses.staffRecordsSubmit(this.enrollmentId, this.staffs.requestId),
        () => {
          this.$toasted.success('Запись успешно произведена', { duration: 2000 });
          this.init();
        },
      );
    },
    async removeStaff(item) {
      this.$set(this.loading.remove, item.id, true);
      await this.$rHandler(
        this.$api.courses.staffRecordsRemoveUser(this.courseId, item.id),
        async () => {
          await this.getStaffRecords();
          if (this.staffs.selected && (item.id === this.staffs.selected.id)) {
            this.staffs.selected = null;
          }
          this.init();
          this.$toasted.success('Сотрудник исключен', { duration: 2000 });
        },
      );
      this.$set(this.loading.remove, item.id, false);
    },
    nextPerson() {
      const idx = this.staffs.items.findIndex((i) => i.id === this.staffs.selected.id);
      this.staffs.selected = this.staffs.items[idx + 1];
    },
    async onSaveForm() {
      await this.getStaffRecords();
      this.fetchContracts();
      this.nextPerson();
    },
    getFullName(l, f, p) {
      return `${l} ${f} ${p}`;
    },
    choicePerson() {
      this.$modals.show('pick-staff', {
        courseId: this.courseId,
        excludedDispatcherList: this.staffs.items
          .filter((el) => !!el.dispatcher_id).map((i) => i.dispatcher_id),
        excludedList: this.staffs.items
          .filter((el) => !el.user_id).map((i) => i.id),
        successCallback: () => {
          this.init();
          this.$modals.close();
        },
      });
    },
  },
};
</script>
